import { useState } from 'react'

import Link from '~/core/Link'

import OnBoardDrawer from './OnBoardDrawer'

const PLACEMENT = 'top-nav'

// Leaving the props inline as this is temporary
export default function OnBoardLink() {
    const [onBoardDrawerVisible, setOnBoardDrawerVisible] = useState(false)

    return (
        <>
            <Link
                name="get-help"
                placement={PLACEMENT}
                onClick={(evt: Event) => {
                    evt.preventDefault()
                    setOnBoardDrawerVisible(true)
                }}
            >
                Help & Resources
            </Link>
            <OnBoardDrawer
                visible={onBoardDrawerVisible}
                onClose={() => setOnBoardDrawerVisible(false)}
            />
        </>
    )
}
